// Utilities
import { SETTINGS } from "@/utils/constants";
import { ICommunityFactorySchema } from "@/utils/types";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useAppStore = defineStore(
  "app",
  () => {
    const darkMode = ref(true);
    const language = ref<string>(SETTINGS.languages[0] || "en");
    const activeFactorySchema = ref<ICommunityFactorySchema>();
    const isSdkInitialized = ref(false);

    function toggleDarkMode() {
      darkMode.value = !darkMode.value;
    }

    function setActiveLanguage(lang: string) {
      language.value = lang;
    }

    return {
      darkMode,
      language,
      toggleDarkMode,
      setActiveLanguage,
      activeFactorySchema,
      isSdkInitialized,
    };
  },
  { persist: true }
);
